import React from 'react'
import Select from 'react-select'
import { get, some, every, isEmpty, filter, includes, map } from 'lodash'

const filteredData = ({ vms, filters }) => filter(vms, (vm) => {
  const filterResults = {}

  if (filters.locations != 'all') {
    filterResults['locations'] = some(filters.locations, location => location.value === get(vm, 'location_id'))
  }

  if (filters.toolsStatus != 'all') {
    filterResults['toolsStatus'] = some(filters.toolsStatus, ({ value }) => value === get(vm, 'tools_status'))
  }

  if (filters.cluster != 'all') {
    filterResults['cluster'] = some(filters.cluster, ({ value }) => value === get(vm, 'cluster'))
  }

  if (filters.toolsState != 'all') {
    filterResults['toolsState'] = some(filters.toolsState, ({ value }) => value === get(vm, 'tools_state'))
  }

  if (filters.guestOs != 'all') {
    filterResults['guestOs'] = some(filters.guestOs, ({ value }) => value === get(vm, 'guest_os'))
  }

  if (filters.powerState != 'all') {
    filterResults['powerState'] = filters.powerState === get(vm, 'power_state')
  }

  return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
})

const VMReportFilters = ({ filters, changeFilters, filterOptions }) => {
  const clusterOptions = () => {
    if (filters.locations != 'all') {
      return filter(filterOptions.cluster, cluster => includes(
        map(filters.locations, 'value'),
        cluster.locationId
      ))
    }

    return filterOptions.cluster
  }

  return (
    <div className="container-fluid" style={{ marginTop: '10px', marginBottom: '10px' }}>

      <div className='row'>
        <div className="col">
          Location
          <Select
            id='vmsLocationFilter'
            isMulti
            value={filters.locations}
            options={filterOptions.locations}
            onChange={options => {
              let locations = options
              if (isEmpty(options)) { locations = 'all' }

              changeFilters({ ...filters, locations })
            }}
          />
        </div>

        <div className="col">
          Cluster
          <Select
            id='vmsClusterFilter'
            isMulti
            value={filters.cluster}
            options={clusterOptions()}
            onChange={options => {
              let cluster = options
              if (isEmpty(options)) { cluster = 'all' }

              changeFilters({ ...filters, cluster })
            }}
          />
        </div>

        <div className="col">
          Tools Status
          <Select
            id='vmstoolsStatusFilter'
            isMulti
            value={filters.toolsStatus}
            options={filterOptions.toolsStatus}
            onChange={options => {
              let toolsStatus = options
              if (isEmpty(options)) { toolsStatus = 'all' }

              changeFilters({ ...filters, toolsStatus })
            }}
          />
        </div>

        <div className="col">
          Tools State
          <Select
            id='vmstoolsStateFilter'
            isMulti
            value={filters.toolsState}
            options={filterOptions.toolsState}
            onChange={options => {
              let toolsState = options
              if (isEmpty(options)) { toolsState = 'all' }

              changeFilters({ ...filters, toolsState })
            }}
          />
        </div>

        <div className="col">
          Guest OS
          <Select
            id='vmsguestOsFilter'
            isMulti
            value={filters.guestOs}
            options={filterOptions.guestOs}
            onChange={options => {
              let guestOs = options
              if (isEmpty(options)) { guestOs = 'all' }

              changeFilters({ ...filters, guestOs })
            }}
          />
        </div>
      </div>
    </div>
  )
}

export { VMReportFilters, filteredData }
